export const getSPermissionFromMenus = (value, state) => {
  let menu = Object.assign({}, ...state.filter((menu) => value === menu.name));
  if (menu) return menu.permissions;
  else return null;
};
